import { TableBody, type TableBodyProps } from '@shared/table-generator';

interface QSetSimilarityMatrixBodyProps {
  rows: TableBodyProps['rows'];
  rowSlotProps: TableBodyProps['slotProps'];
}

export default function QSetSimilarityMatrixBody(props: Readonly<QSetSimilarityMatrixBodyProps>) {
  const { rows, rowSlotProps } = props;

  return <TableBody rows={rows} slotProps={rowSlotProps} />;
}
